import React, { ReactElement } from 'react';

import { Box } from '@bcp-nextgen-dx-component-factory/design-system';
import { DisplayGroupProps } from '@bcp-nextgen-dx-touchpoint-framework/react-js';
import { ComponentInfo, DisplayGroupRender } from '@components';

export const RowContainer: React.FC<DisplayGroupProps> = (props: DisplayGroupProps): ReactElement => {
	return (
		<ComponentInfo
			name="RowContainer"
			as={Box}
			styles={{
				display: 'flex',
				flexDirection: 'row',
			}}
		>
			<DisplayGroupRender displayGroupsProps={props} />
		</ComponentInfo>
	);
};
